import type { Guide } from '../types';

/** S-20.10-07 — pulpit Team Leadera FTL (scenariusz e2e 14). */
export const guide: Guide = {
  flagKey: 'teamLeaderDashboard',
  title: 'Pulpit Team Leadera FTL',
  whatItDoes:
    'Pozycja menu „Pulpit Team Leadera” dla planisty głównego i administratorów. Liczby: zlecenia do obsadzenia z wariantami i bez, konflikty wariantów i warianty po terminie, wnioski o odpięcie, „Straciły pojazd”, „Jutro załadunek, bez auta”, bilans FTL / Trade i alerty przeplanowania. Każda liczba otwiera listę zleceń z tym samym filtrem; ekranem startowym zostaje pulpit ogólny.',
  audience: ['Team Leader (planista główny)', 'administrator'],
  presentationItems: ['S-20.10-07'],
  steps: [
    {
      route: '/ftl-team-leader-dashboard',
      target: 'ftl-tile-toAssignWithoutVariants',
      title: 'Do obsadzenia — z wariantami i bez',
      description:
        '„Do obsadzenia z wariantami” czeka na Twoją decyzję; „bez wariantu” — żaden planista nie wskazał jeszcze pojazdu.',
      action: 'Otwórz „Pulpit Team Leadera” w menu i kliknij kafelek, żeby zobaczyć listę zleceń.',
      recorder: { account: 'master' },
    },
    {
      route: '/ftl-team-leader-dashboard',
      target: 'ftl-tile-unassignRequestsPending',
      title: 'Wnioski o odpięcie',
      description: 'Wnioski planistów o odpięcie pojazdu czekające na Twoją decyzję — akceptacja albo odrzucenie z powodem na karcie zlecenia.',
      action: 'Kliknij kafelek „Wnioski o odpięcie” i rozstrzygnij wniosek na banerze karty zlecenia.',
      recorder: { account: 'master' },
    },
  ],
};
